import * as ko from "knockout";
import {config, global} from "../../../appContext";
import {ICompanyLogin, IMessageData, IRouteParams, TAuthenticationType} from "../../../index";
import {EHUB_IDS} from "../../../constants";
import {isRoutePermissionOkay, setRouteHash} from "../../../constants/RouteDefinitions";
import {PLEASE_WAIT_MESSAGE, REDIRECTING_MESSAGE} from "../../../constants/Language";
import {createErrorMessage, isBit} from "../../../util/misc";
import PromiseRequest from "../../../req/PromiseRequest";
import {EHubManagerOptions} from "../../../../ehub/EHubManager";
import {nsAmplify} from "../../../util/nsAmplify";
import {AuthenticationTypeFlag} from "../../../constants/AuthenticationTypeFlag";
import view_v2Html from './view-v2.html?raw';

export const template = view_v2Html

export class viewModel {

    private companyLogin: ICompanyLogin | undefined;
    private readonly isLoginEnabled: KnockoutObservable<boolean> = ko.observable(false);
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly req_getcompanylogin = global.getPromiseRequest('getcompanylogin');
    private readonly req_getformauthentication: PromiseRequest = new PromiseRequest('getformauthentication');
    private readonly routeParams: IRouteParams | undefined;
    private readonly showLogin: KnockoutObservable<boolean> = ko.observable(false);
    private requiredAuthType!: number;

    constructor() {
        this.routeParams = global.router.currentRoute()?.__routeParams;
        if (!this.routeParams) {
            this.messageData(createErrorMessage('Missing route parameters'));
            return;
        }
        this.init()
    }

    private init() {
        const routeParams = this.routeParams;
        if (!routeParams) {
            return;
        }
        this.messageData({message: PLEASE_WAIT_MESSAGE})
        Promise.resolve()
            .then(() => this.req_getformauthentication
                .request({
                    id: routeParams['id'],
                    orgnr: routeParams['orgnr'],
                })
                .then((data: [number]) => {
                    this.requiredAuthType = data[0] ?? 0
                    return isBit(global.login.user()?.authenticationtype ?? 0, this.requiredAuthType);
                })
            )
            .then((isValidAuthType: boolean) => {
                if (isValidAuthType) {
                    this.initForm()
                } else {
                    this.initLogin()
                }
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    private initForm() {
        this.messageData(null)
        const routeParams = global.router.currentRoute()?.__routeParams
        if (!routeParams) {
            return;
        }
        if (!global.eHubManager.isStarted()) {
            const mode = !!parseInt(routeParams['preview'] ?? '0', 10) ? 'preview': 'submit'
            const options: Partial<EHubManagerOptions> = {
                form: routeParams['id'],
                mode: mode,
                orgnr: routeParams['orgnr'],
                targetId: routeParams['targetid'],
            };
            global.eHubManager.start(options)
            const el_ehub = document.getElementById(EHUB_IDS.ehub_id)
            if (!el_ehub) {
                return;
            }
            el_ehub.addEventListener('cancel', () => {
                global.snackbarData({message: '((form)): ((cancelled|ac))'})
                this.doNextRoute()
            }, false)
            el_ehub.addEventListener('submit', () => {
                global.snackbarData({message: '((form)): ((submitted|ac))'})
                this.doNextRoute()
            }, false)
        }
    }

    private initLogin() {
        return this.req_getcompanylogin
            .request()
            .then((data: ICompanyLogin[]) => {
                this.companyLogin = data.find(o => o.orgnr == this.routeParams!['orgnr'])
                this.messageData(null)
                this.showLogin(true)
            })
    }

    private doNextRoute() {
        const isUserStartOkay = isRoutePermissionOkay('userstart')
        if (isUserStartOkay) {
            setRouteHash('userstart')
        } else {
            setRouteHash('myprofile')
        }
    }

    private isLogin(loginType: 'aad' | 'eadm' | 'idporten'): boolean {
        const _isBit = (authType: TAuthenticationType) => isBit(authType, this.requiredAuthType);
        switch (loginType) {
            case "aad":
                return _isBit(AuthenticationTypeFlag.AAD_FEDERATION);
            case "eadm":
                return _isBit(AuthenticationTypeFlag.EADM_NATIVE) || _isBit(AuthenticationTypeFlag.EADM_NATIVE_SMS);
            case "idporten":
                return _isBit(AuthenticationTypeFlag.ID_PORTEN);
            default:
                return false;
        }
    }

    private onLoginClick(loginType: 'aad' | 'eadm' | 'idporten') {
        const routeParams = global.router.currentRoute()?.__routeParams;
        if (!routeParams || !this.routeParams) {
            return;
        }
        nsAmplify.store("lastHash", routeParams.request_);

        switch (loginType) {
            case "aad": {
                this.messageData({message: REDIRECTING_MESSAGE});
                const topWindow = window.top;
                if (topWindow) {
                    topWindow.location.href = `${config.getUrlIdentityHub()}login/aad-${this.routeParams['orgnr']}/${encodeURIComponent(document.URL)}`
                }
                break;
            }
            case "eadm": {
                setRouteHash('formlogin', {orgnr: this.routeParams['orgnr']})
                break;
            }
            case "idporten": {
                this.messageData({message: REDIRECTING_MESSAGE});
                const topWindow = window.top;
                if (topWindow) {
                    topWindow.location.href = `${config.getUrlIdentityHub()}login/idporten-${this.routeParams['orgnr']}/${encodeURIComponent(document.URL)}`;
                }
                break;
            }
        }
    }

    dispose() {
        this.req_getcompanylogin.abort()
        this.req_getformauthentication.abort()
    }

}